import PropTypes from 'prop-types';
import getBlockClasses from './get-block-classes';
import { renderChildren } from '@blaze-cms/react-page-builder';
import { LANDSCAPE_WITH_AD, COLUMN_CLASSES } from './constants';

const LandscapeWithAdCardsBlock = ({ cardsSeparator, combined, channel, parsedChildren, withTitle }) => {
  if (parsedChildren.length < 2) return null;

  return (
    <div className={getBlockClasses(LANDSCAPE_WITH_AD, { cardsSeparator, combined, channel, withTitle })}>
      <div className={COLUMN_CLASSES}>
        {renderChildren(parsedChildren[0])}
      </div>

      <div className={COLUMN_CLASSES}>
        {renderChildren(parsedChildren[1])}
      </div>
    </div>
  );
};

LandscapeWithAdCardsBlock.propTypes = {
  cardsSeparator: PropTypes.bool.isRequired,
  combined: PropTypes.bool.isRequired,
  channel: PropTypes.string,
  parsedChildren: PropTypes.array.isRequired,
  withTitle: PropTypes.bool.isRequired
};

export default LandscapeWithAdCardsBlock;
